/**
 * createPersist
 *
 * @param  {String} namespace       namespace
 * @param  {Object} [config]        provider/serialize/deserialize
 * @return {Object}                 get/set
 */

function createPersist(namespace, config) {
  const { provider, serialize, deserialize } = Object.assign(
    {
      provider: window.localStorage,
      serialize: JSON.stringify,
      deserialize: JSON.parse,
    },
    config,
  );

  if (!namespace) {
    namespace = 'default';
  }

  return {
    /**
     * get
     *
     * @param  {String} key   key, defaults to 'default'
     * @return {Object}       plain object
     */
    get(key = 'default') {
      let state = null;

      try {
        const { value, expires } = deserialize(provider.getItem(`${namespace}-${key}`));

        if (expires === 0 || expires > Date.now()) {
          // always a plain object
          state = deserialize(value);
        }
      } catch (e) {
        state = null;
        // console.log(e)
      }

      if (state === null) {
        return null;
      }
      if (state.constructor === Array) {
        return state.slice(0);
      }

      return Object.assign({}, state);
    },

    /**
     * exists
     *
     * @param  {String} key   key to test
     * @return {Boolean}
     */
    exists(key) {
      try {
        const { value, expires } = deserialize(provider.getItem(`${namespace}-${key}`));

        return !!value && (expires === 0 || expires > Date.now());
      } catch (e) {
        return false;
      }
    },

    /**
     * set
     *
     * @param  {String} key   key
     * @param  {Object} value plain object
     * @param  {Number} expires the optional expiration timeout
     * @return {undefined}
     */
    set(key, value, expires = 0) {
      if (arguments.length === 1) {
        value = key;
        key = 'default';
      }
      try {
        provider.setItem(
          `${namespace}-${key}`,
          serialize({
            value: serialize(value),
            expires: expires ? expires + Date.now() : expires,
          }),
        );
      } catch (e) {
        // console.log(e)
      }
    },

    /**
     * @param {String} key key
     * @return {undefined}
     */
    remove(key) {
      try {
        provider.removeItem(`${namespace}-${key}`);
      } catch (e) {
        // console.log(e)
      }
    },
  };
}

export { createPersist };
export default createPersist;
